export const clickScroll = () => {
    try {
        var elem = document.getElementById("Texts");
        elem.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch {
    }
}